const RadioButtonOption = ({ id, imageSrc, langTitle, selected, onSelect }) => {
    return (
        <label className={`radio-label ${selected ? 'selected' : ''}`}>
            <input
                type='radio'
                id={id}
                name={langTitle}
                className='radio-input'
                checked={selected}
                onChange={() => onSelect(id)}
            />
            <div className='d-flex'>
                <img src={imageSrc} alt={`Image ${id}`} className='radio-image' />
                <div className='active'></div>
            </div>
            <span className='mx-2 label-lang'>{langTitle}</span>
        </label>
    );
};

export default RadioButtonOption;
